module.exports = __webpack_public_path__ + "static/media/Anna Brightman, Co-Founder - UpCircle.a2eb4dfa.png";